<template>
  <div class="video-index-page">
    <div :class="videoListShow?'list-btn list-btn-open':'list-btn'" @click="videoListShow=!videoListShow"><i :class="videoListShow?'el-icon-arrow-left':'el-icon-arrow-right'"></i></div>
    <div :class="videoListShow?'video-list video-list-open':'video-list'">
      <div class="list-box">
        <div class="left-head">
          {{$t('camera.camera_list')}}
          <div class="add-camera"  @click="openEditWin('create')"><i class="el-icon-plus"></i></div>
        </div>
        <ul>
          <li v-for="(item, index) in videoList" :key="index">
            <div class="item-one" @click="setDeviceToBind(item.number,item.channel)">{{item.title}}</div>
            <el-dropdown trigger="click" class="device-set" @command="setCommand">
              <div class="set-btn"><i class="el-icon-setting"></i></div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="drop-item" :command="{type:'update',item:item}">{{$t('camera.config_edit')}}</el-dropdown-item>
                <el-dropdown-item class="drop-item" :command="{type:'delete',item:item}">{{$t('camera.delete_camera')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
    </div>
    <div class="video-box" :class="`videos-${videos.length}`">
      <video-box
        ref="child"
        class="video-preview"
        :class="{ 'is-binding': deviceToBind }"
        v-for="(video, index) in videos"
        :key="index"
        :activated="activatedVideo === video"
        :video="video"
        :rnd="video.rnd"
        @click.native="deviceToBind ? bindDevices(video) : activeVideo(video)">
      </video-box>
    </div>

    <div :class="controlShow?'control-btn control-btn-open':'control-btn'" @click="controlShow=!controlShow"><i :class="controlShow?'el-icon-arrow-right':'el-icon-arrow-left'"></i></div>
    <div :class="controlShow?'control-box control-open':'control-box'">
      <div class="control-con">
        <div class="video-control"><video-control :video="activatedVideo"></video-control></div>
        <div class="slice-box">
          <div class="slice-control">
            <div class="control-item" :class="videos.length==1?'curr':''" @click="createVideos(1)"></div>
          </div>
          <div class="slice-control">
            <div class="control-item" :class="videos.length==4?'curr':''" @click="createVideos(4)"><img src="@/assets/images/control-4.png" /></div>
          </div>
          <div class="slice-control">
            <div class="control-item" :class="videos.length==9?'curr':''" @click="createVideos(9)"><img src="@/assets/images/control-9.png" /></div>
          </div>
        </div>
      </div>
    </div>

    <!--新增对话框-->
    <el-dialog
      class="dialog650"
      :title="editType === 'create' ? $t('camera.add_camera') : $t('camera.edit_camera')"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left" 
        :rules="editOneRule"
        :label-width="$i18n.locale==='zh-CN'?'100px':'120px'"
      >
        <div class="form-info">
          <el-form-item :label="$t('camera.name')" prop="title" class="xing-tips">
            <el-input v-model="editOne.title" :placeholder="$t('camera.enter_name')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('camera.number')" prop="number" class="xing-tips">
            <el-input v-model="editOne.number" :placeholder="$t('camera.enter_number')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('camera.type')">
            <el-select
              filterable 
              :placeholder="$t('camera.select_type')"
              v-model="editOne.camera_type"
              style="width: 100%"
            >
              <el-option :label="$t('camera.haikang')" :value="1"></el-option>
              <el-option :label="$t('camera.dahua')" :value="2"></el-option>
              <el-option :label="$t('camera.qiniuyun')" :value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="editOne.camera_type==3" :label="$t('camera.qiniuyun_key')">
            <el-input v-model="editOne.qiniu_key" :placeholder="$t('camera.enter_qiniuyun_key')"></el-input>
          </el-form-item>
          <el-form-item v-if="editOne.camera_type==3" :label="$t('camera.qiniuyun_secret')" >
            <el-input v-model="editOne.qiniu_secret" :placeholder="$t('camera.enter_qiniuyun_secret')"></el-input>
          </el-form-item>

          <el-form-item :label="$t('camera.select_lamp')">
            <el-select
              clearable
              filterable 
              :placeholder="$t('camera.enter_select_lamp')"
              v-model="editOne.lamp_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in lampList"
                :key="t.lamp_id"
                :label="t.name"
                :value="t.lamp_id"
              ></el-option>
            </el-select>
          </el-form-item>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="checkbox-item">
              <el-checkbox :true-label="1" :false-label="0" v-model="editOne.is_display">{{$t('camera.is_home')}}</el-checkbox>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box-footer">
              <el-button
                size="medium"
                class="cancel-btn"
                @click="dialogVisible = false"
                >{{$t('control.cancel')}}</el-button >
  
              <el-button
                v-if="editType === 'create'"
                type="primary"
                size="medium"
                @click="createItem"
                >{{$t('control.confirm')}}</el-button>
              <el-button
                v-if="editType === 'update'"
                type="primary"
                size="medium"
                @click="updateItem"
                >{{$t('control.confirm')}}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import lampsApi from "@/api/device/lamps";
import cameraApi from "@/api/device/camera";
import videoBox from '@/components/video/VideoBox.vue'
import videoControl from '@/components/video/VideoControl.vue'
export default {
  components: {
    videoBox,
    videoControl
  },
  data () {
    return {
      controlShow: true,
      videoListShow: true,
      videoList: [],
      videos: [],
      deviceToBind: null,
      activatedVideo: {},
      controlSpeed: 50,
      editType: -1,
      lampList: [],
      dialogVisible: false,
      editOne: {
        number: '',
        title: '',
        camera_type: null,
        qiniu_key: '',
        qiniu_secret: '',
        lamp_id: null,
        is_display: 0
      },
      editOneRule: {
        title: [{ required: true, message: this.$t('camera.enter_name'), trigger: "blur" }],
        number: [{ required: true, message: this.$t('camera.enter_number'), trigger: "blur" }],
        camera_type: [{ required: true, message: this.$t('camera.select_type'), trigger: "blur" }]
      }
    }
  },
  mounted () {
    this.getCameraList()
  },
  methods: {
    getCameraList() {
      cameraApi.cameraList({
        page: 1,
        pageSize: 200,
      }).then((res) => {
        if (res.data.code === 1000) {
          this.videoList = res.data.data.list;
          if(res.data.data.list.length) {
            // this.getFirstVideo(res.data.data.list[0].number, res.data.data.list[0].channel)
            this.createVideos(4)
          }
          this.getLampList()
        }
      });
    },
    createVideos (count) {
      if ([1, 4, 9].indexOf(count) < 0) {
        return
      }
      if (count > this.videos.length) {
        for (let i = this.videos.length; i < count; i++) {
          this.videos.push({
            index: i,
            number: '',
            camera_type: 1,
            channel: 1,
            access_token: '',
            rnd: Math.random()
          })
        }
      } else if (count < this.videos.length) {
        const videos = []
        for (let i = 0; i < count; i++) {
          videos.push(this.videos[i])
        }
        this.videos = videos
      }
    },
    setDeviceToBind (number,channel) {
      if (this.deviceToBind && this.deviceToBind.number === number) {
        this.deviceToBind = null
      } else {
        cameraApi.cameraInfo({
          number: number,
          channel: channel
        }).then((res) => {
          if (res.data.code === 1000) {
            const {camera_type, channel, access_token} = res.data.data
            this.deviceToBind = {
              number: number,
              camera_type: camera_type,
              channel: channel,
              access_token: access_token
            }
            this.activatedVideo = this.deviceToBind
          }
        })
      }
    },
    bindDevices (video) {
      video.rnd = Math.random()
      video.number = this.deviceToBind.number //设备序列号
      video.camera_type = this.deviceToBind.camera_type //设备序列号
      video.channel = this.deviceToBind.channel //通道号
      video.access_token = this.deviceToBind.access_token //通道号
      this.deviceToBind = null
    },
    activeVideo (video) {
      if (this.activatedVideo === video) {
        this.activatedVideo = null
      } else {
        this.activatedVideo = video
      }
    },
    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          number: '',
          title: '',
          camera_type: null,
          qiniu_key: '',
          qiniu_secret: '',
          lamp_id: null,
          is_display: 0
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          title: index.title,
          number: index.number,
          camera_type: index.camera_type,
          qiniu_key: index.qiniu_key,
          qiniu_secret: index.qiniu_secret,
          lamp_id: index.lamp_id,
          is_display: index.is_display
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },
    setCommand(command) {
      if(command.type=='update'){
        this.openEditWin(command.item)
      }else{
        this.delItem(command.item.id)
      }
    },
    updateItem() {
      cameraApi.cameraEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.mod_success'));
          this.dialogVisible = false;
          this.getCameraList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      cameraApi.cameraAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.add_success'));
          this.dialogVisible = false;
          this.getCameraList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm(this.$t('camera.delete_camera_tip'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          cameraApi.cameraDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.del_success'));
              this.getCameraList();
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del'),
          });
        });
    },
    getLampList() { // 获取路灯列表
      lampsApi.lightList({
        page: 1,
        pageSize: 500,
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.lampList = resData.list;
        }
      });
    }
  }
}
</script>

<style lang='less'>
@color-primary:#0c82fe;
.video-index-page {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  .list-btn{
    position: absolute;
    z-index: 999;
    left:40px;
    top:32px;
    background-color: @color-primary;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    width:40px;
    height:40px;
    font-size: 28px;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    transition: all 0.5s;
    &.list-btn-open{
      left:242px;
    }
  }
  .video-list{
    width:0;
    height:100%;
    overflow: hidden;
    background-color: #fff;
    transition: all 0.5s;
    box-sizing: border-box;
    &.video-list-open{
      width:262px;
    }
    .list-box{
      width:262px;
      padding:15px 20px 20px 25px;
      height:100%;
      overflow-y: auto;
      position: relative;
      box-sizing: border-box;
      .left-head{
        height:40px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        font-weight: bold;
        color: #333;
        .add-camera{
          background-color: @color-primary;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          width:22px;
          height:22px;
          font-size: 16px;
          border-radius: 50%;
          cursor: pointer;
          font-weight: normal;
          margin-right: 10px;
        }
      }
      ul {
        list-style: none;
        margin: 0;
        padding: 0;
        li{
          margin-top:10px;
          position: relative;
          .item-one {
            overflow: hidden;
            // text-overflow:ellipsis;
            // white-space: nowrap;
            font-size: 14px;
            cursor: pointer;
            color:#444;
            padding: 10px 40px 10px 0;
            font-weight: bold;
            line-height: 1.2;
            &:hover {
              color:@color-primary;
            }
          }

          .device-set{ 
            position: absolute;
            right:7px;
            top:5px;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            .set-btn{
              color:#444;
              font-size: 20px;
              cursor: pointer;
              &:hover {
                color:@color-primary !important;
              }
            }
            
          }
        }
        
      }
    }
  }
  .video-box{
    width:100%;
    height:100%;
    flex: 1;
    position: relative;
    padding:20px;
    box-sizing: border-box;
    background-color: #000;
  }
  .control-btn{
    position: absolute;
    z-index: 999;
    right:40px;
    bottom:40px;
    background-color: @color-primary;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    width:40px;
    height:40px;
    font-size: 28px;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    transition: all 0.5s;
    &.control-btn-open{
      right:538px;
      bottom:310px;
    }
  }
  .control-box{
    width:0;
    height:0;
    overflow: hidden;
    transition: all 0.5s;
    box-sizing: border-box;
    position: absolute;
    right:0;
    bottom: 0;
    z-index: 998;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    &.control-open{
      width:560px;
      height:380px;
    }
    .control-con{
      width:560px;
      height:380px;
      position: relative;
      box-sizing: border-box;
      background-color: #333333;
      display: flex;
      .video-control{
        flex: 1;
        width:100%;
        height:380px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .slice-box{
        border-left: 1px solid #000;
        width:140px;
        height:380px;
        display: flex;
        flex-direction: column;
        .slice-control{
          width:100%;
          flex:1;
          display: flex;
          align-items: center;
          justify-content: center;
          .control-item {
            width: 94px;
            height: 94px;
            border-radius: 8px;
            background: #1c2029;
            border:3px solid #333333;
            cursor: pointer;
            box-sizing: border-box;
            line-height: 0;
            img {
              width:100%;
              height:100%;
            }
            &.curr{
              border:3px solid @color-primary;
            }
          }
        }
      }
    }
  }
    
  .drop-item{
    font-size: 14px;
    color:#333;
    padding:2px 10px;
    text-align: center;
  }

  .video-container {
    width: 100%;
    height: 100%;
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
  }
  .videos-1 .video-container {
    width: 100%;
    height: 100%;
  }
  .videos-4 .video-container {
    width: 50%;
    height: 50%;
  }
  .videos-9 .video-container {
    width: 33.333333%;
    height: 33.333333%;
  }
  .video-preview.is-binding {
    cursor: pointer;
  }
  .video-preview.is-binding:before {
    content: '在这里显示';
    display: block;
    position: absolute;
    font-size: 24px;
    color: #fff;
    background: #000;
    width: 100%;
    height: 100%;
    text-align: center;
    box-sizing: border-box;
    padding-top: 2em;
    opacity: 0.5;
    z-index: 2;
  }
  .video-preview.is-binding:hover:before {
    opacity: 0.7;
  }

  .form-info{
    padding-left: 20px;
    .el-form-item__label{
      width:110px;
    }
  }
}
</style>
